export default {
  heading: "变更密码",
  currentPassword: "现有密码",
  newPassword: "新密码",
  confirmNewPassword: "再次确认新密码",
  passwordStrength: "密码强度：",
  lengthInfo: "密码必须包含至少{minlength}个字元",
  complexText: {
    1: "可使用大写与小写字母、数字或符号",
    2: "以及下列任何两项：大写字母、小写字母、数字或符号",
    3: "以及下列任何三项：大写字母、小写字母、数字或符号",
    4: "以及下列四项：大写字母、小写字母、数字和符号"
  },
  strength: {
    0: "很弱",
    1: "弱",
    2: "中",
    3: "强",
    4: "很强"
  },
  currentPasswordIsEmpty: "请输入现有密码。",
  currentPasswordIsWrong: "您所输入的现有密码不正确。",
  newPasswordIsEmpty: "请输入新密码。",
  newPasswordIsNotSecurity: "您所输入的新密码未达安全要求，请重新输入。",
  newPasswordIsSameAsOld: "新密码与旧密码相同，请重新输入。",
  confirmNewPasswordIsEmpty: "请再次确认新密码。",
  confirmNewPasswordIsNotSame: "您所输入的密码不符，请重新输入。",
  confirmDialogContent: "确定新密码？",
  confirmUpdate: "确定",
  cancelUpdate: "取消",
  closeBtn: "关闭",
};
